module.exports = require("./fr-KM.d.ts");